import fetch from '@/helpers/fetch'

export default {
	state: {
		calcsEach: [],
		calcsPrint: [],
	},
	mutations: {
		SET_CALCS_EACH(state, list) {
			state.calcsEach = list
		},
		SET_CALCS_PRINT(state, list) {
			state.calcsPrint = list
		},
	},
	actions: {
		setCalcsEach: function (context, calcs) {
			context.commit('SET_CALCS_EACH', calcs)
		},
		setCalcsPrint: function (context, calcs) {
			context.commit('SET_CALCS_PRINT', calcs)
		},
	},
}
